import React from "react";
import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface ViewAllToggleProps {
  expanded: boolean;
  onToggle: () => void;
  showToggle: boolean;
}

export const ViewAllToggle: React.FC<ViewAllToggleProps> = ({
  expanded,
  onToggle,
  showToggle,
}) => {
  const { t } = useTranslation("common");

  if (!showToggle) {
    return null;
  }

  return (
    <Text
      as="button"
      onClick={onToggle}
      color="#5C6670"
      fontSize="14px"
      fontWeight={500}
      _hover={{ textDecoration: "underline" }}
      data-tour-item="view-all-button"
    >
      {expanded ? t("kpecDashboard.viewLess") : t("kpecDashboard.viewAll")}
    </Text>
  );
};

export default ViewAllToggle;
